import React, { useEffect, useState } from "react";
import styles from "./Menu.module.scss";
import { MenuItemType, MenuType, PlatformType } from "../../../types/baseTypes";
import MenuItem from "./MenuItem/MenuItem";
import { useKeyboardNavigation } from "./keyboard-navigation";
import { Post } from "@/wp/types/client";
import { OptionsPromoBoxConfigType } from "@/types/OptionType";
import { LanguageToggle } from "../Language/LanguageToggle";
import { pathTranslator } from "@/utils/language";
import { useAppContext } from "../../../context/AppContext";
/* jscpd:ignore-start */
interface MenuProps {
  menu: MenuType;
  isHome: boolean;
  pageData?: Post;
  promoBoxOption: OptionsPromoBoxConfigType;
  socialMedia: PlatformType;
  promoLink: MenuItemType;
  isNobleElements?: boolean;
}

export type MenuParentType = MenuItemType | undefined;

export const Menu = ({
  menu,
  isHome,
  pageData,
  promoBoxOption,
  socialMedia,
  promoLink,
  isNobleElements,
}: MenuProps) => {
  const { openMenu } = useAppContext();
  const [currentSubmenu, setCurrentSubmenu] = useState<MenuParentType>();

  const availableTranslations = pageData ? pathTranslator(pageData) : [];

  const { menuRef, items, focusedItem, keyDown, controlMenu } =
    useKeyboardNavigation({
      menu,
      setCurrentSubmenu,
      type: "menu",
      subMenu: undefined,
    });

  useEffect(() => {
    const handleFocusChange = (event: FocusEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) {
        setCurrentSubmenu(undefined);
      }
    };

    document.addEventListener("focusin", handleFocusChange);

    return () => {
      document.removeEventListener("focusin", handleFocusChange);
    };
  }, [menuRef]);

  const menuItems = Array.isArray(menu.items)
    ? [...menu.items, promoLink]
    : [promoLink];

  return (
    <div className={styles["menu-wrapper"]}>
      <ul
        ref={menuRef}
        role="menubar"
        aria-label="Hauptmenü"
        className={`${styles["main-menu"]} ${openMenu ? styles["is-open"] : ""}`}
        onKeyDown={keyDown}
      >
        {menu &&
          menuItems.map((item, key) => {
            if (!items.current[key]) {
              items.current[key] = React.createRef<HTMLLIElement>();
            }
            return (
              <MenuItem
                item={item}
                key={key}
                isHome={isHome}
                pageData={pageData}
                currentSubmenu={currentSubmenu}
                setCurrentSubmenu={setCurrentSubmenu}
                parentSubMenu={undefined}
                subMenu={item}
                tabIndex={key === focusedItem.current ? 0 : -1}
                itemRef={items.current[key]}
                controlParentMenu={controlMenu}
                promoBoxOption={promoBoxOption}
                socialMedia={socialMedia}
                isNobleElements={isNobleElements}
              />
            );
          })}

        {availableTranslations.length > 0 && pageData && (
          <li className="is-hidden-after-navbar-breakpoint menu-item my-0 mx-auto py-4 px-5">
            <LanguageToggle addWrapper={true} post={pageData} />
          </li>
        )}
      </ul>
    </div>
  );
};

/* jscpd:ignore-end */
